import {z} from 'zod';

export enum ProjectStatus {
	CLOSED = 'closed',
	OPEN = 'open',
}

export enum ProjectApprovalMode {
	ALL = 'all',
	ANY = 'any',
	NONE = 'none',
}

export const AssetProjectDetailedSchema = z.object({
	id: z.string(),
	title: z.string(),
	description: z.string(),
	status: z.nativeEnum(ProjectStatus),
	approvalMode: z.nativeEnum(ProjectApprovalMode),
	approvers: z.object({
		all: z.boolean(),
		none: z.boolean(),
		userIds: z.array(z.number()),
		groupIds: z.array(z.number()),
		emails: z.array(z.string()),
	}),
	dueDate: z.string(),
	hasApprovers: z.boolean(),
	hasDecisions: z.boolean(),
	creationDate: z.string(),
	creationUser: z.number(),
	creationUserEmail: z.string(),
	creationUserLabel: z.string(),
	modDate: z.string(),
	modUser: z.number(),
	permission: z.string(),
});

export type IAssetProjectDetailed = z.infer<typeof AssetProjectDetailedSchema>;

export const AssetProjectSchema = AssetProjectDetailedSchema.pick({
	id: true,
	title: true,
	description: true,
	status: true,
	creationDate: true,
	creationUser: true,
	creationUserEmail: true,
	creationUserLabel: true,
	dueDate: true,
	contentCount: true,
	participantCount: true,
	permission: true,
});

export type IAssetProject = z.infer<typeof AssetProjectSchema>;
